<div class="profile-picture-wrapper">
  <app-profile-picture
    [name]="name"
    [userData]="userData"
    [font]="font"
  >
  </app-profile-picture>
  <span
    *ngIf="showDeactivated"
    class="deactivated-badge"
    [ngClass]="type"
  >
    <img [src]="deactivatedIconSrc" class="deactivated-icon" />
  </span>
</div>